export const getDefaultBidDescriptionStyles = () => ({
  root: {
    padding: '10px 0',
  },
});
